var $ = require('jquery');
require('slick-carousel');

var Sliders = function Sliders() {
	var $gallery = $('.gallery .inner');
	if($gallery.length) {
		$gallery.slick({
			cssEase: 'ease-in-out',
			slidesPerRow: 6,
			slidesToShow: 6,
			prevArrow: '<div class="action prev"><i class="fa fa-caret-left fa-3x"></i></div>',
			nextArrow: '<div class="action next"><i class="fa fa-caret-right fa-3x"></i></div>',
			responsive: [
				{
					breakpoint: 850,
					settings: {
						slidesPerRow: 4,
						slidesToShow: 4		
					}
				}
			]
		});
	}
}

module.exports = Sliders;